export interface CatalogAdjustmentType {
	AdjustmentTypeId: number | null;
	AdjustmentTypeName: string;
	RequiredValue: boolean;
	RequiredReason: boolean;
	Unit: string | null;
	IsActive: boolean;
}

export const ADJUSTMENT_TYPE_INITIAL_VALUES: CatalogAdjustmentType = {
	AdjustmentTypeId: null,
	AdjustmentTypeName: "",
	RequiredValue: true,
	RequiredReason: true,
	Unit: "",
	IsActive: true,
};
